module.exports = __webpack_public_path__ + "static/walk-by-faith-7e276d08ab035e2511aa311dbfc4cb68.mp3";